/* Top Racing Point - prodotti con optional da spuntare (template product.caselle). Vedi snippets/trp-caselle.liquid */
(function(){
  var SENZA=/^senza optional$/i, OPT=/\s*\(optional\)\s*$/i;
  function ready(fn){ if(document.readyState!=='loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
  function el(tag,cls,txt){ var e=document.createElement(tag); if(cls) e.className=cls; if(txt!=null) e.textContent=txt; return e; }

  ready(function(){
    var root=document.querySelector('[data-trp-cas]'); if(!root) return;
    var D=JSON.parse(root.querySelector('[data-trp-cas-data]').textContent);
    var V=D.variants, N=D.options||[];
    var body=root.querySelector('[data-trp-cas-body]');
    var btn=root.querySelector('[data-trp-cas-add]'), info=root.querySelector('[data-trp-cas-info]'),
        tot=root.querySelector('[data-trp-cas-total]'), cmp=root.querySelector('[data-trp-cas-compare]'),
        save=root.querySelector('[data-trp-cas-save]'), msg=root.querySelector('[data-trp-cas-msg]'),
        qty=root.querySelector('[data-trp-cas-qty]');
    var fmt=new Intl.NumberFormat('it-IT',{style:'currency',currency:root.getAttribute('data-currency')||'EUR'});
    function soldi(c){ return fmt.format(c/100); }
    function valori(i){ var s=[]; V.forEach(function(v){ if(s.indexOf(v.options[i])<0) s.push(v.options[i]); }); return s; }

    // ---- riconoscimento del tipo di prodotto
    var modo='', iSpec=-1;
    N.forEach(function(n,i){
      var vals=valori(i);
      if(iSpec<0 && vals.some(function(x){ return SENZA.test(x); })){ modo='A'; iSpec=i; }
    });
    if(!modo) N.forEach(function(n,i){ if(iSpec<0 && valori(i).some(function(x){ return OPT.test(x); })){ modo='B'; iSpec=i; } });
    if(!modo) N.forEach(function(n,i){ if(iSpec<0 && /^articol/i.test(n)){ modo='C'; iSpec=i; } });
    // prodotto con una sola opzione e piu articoli (es. kit Whiteline): ogni articolo e una casella
    if(!modo && N.length===1 && valori(0).length>1){ modo='C'; iSpec=0; }
    if(!modo){ modo='S'; }  // solo scelte obbligatorie

    var gruppi=[];   // {tipo:'scelta'|'opt', idx, righe:[{input, valore, ...}]}

    function gruppo(titolo,nota){
      var g=el('div','trp-cas__group'), h=el('div','trp-cas__group-head');
      h.appendChild(el('span','trp-cas__gname',titolo)); h.appendChild(el('span','trp-cas__req',nota));
      g.appendChild(h); body.appendChild(g); return g;
    }
    function riga(g,nome,sku){
      var r=el('label','trp-cas__row'), c=el('input','trp-cas__check'); c.type='checkbox';
      var n=el('span','trp-cas__name',nome); if(sku && !/^DS-/i.test(sku)){ n.appendChild(el('span','trp-cas__sku','Cod. '+sku)); }
      var p=el('span','trp-cas__price');
      r.appendChild(c); r.appendChild(n); r.appendChild(p); g.appendChild(r);
      return {riga:r,input:c,prezzo:p};
    }
    function esclusivi(lista){ lista.forEach(function(x){ x.input.addEventListener('change',function(){ if(x.input.checked) lista.forEach(function(o){ if(o!==x) o.input.checked=false; }); }); }); }

    // gruppi obbligatori: tutte le opzioni tranne quella speciale (in B anche i valori "normali" di quella speciale)
    N.forEach(function(n,i){
      if(i===iSpec && modo!=='B') return;
      var vals=valori(i);
      if(i===iSpec) vals=vals.filter(function(x){ return !OPT.test(x); });
      if(!vals.length) return;
      var titolo=(i===iSpec || /^(title|titolo|versione|variante)$/i.test(n)) ? 'Scegli il prodotto' : n;
      var g=gruppo(titolo, vals.length>1 ? 'scegline una *' : 'incluso');
      var righe=vals.map(function(x){ return Object.assign(riga(g,x,''),{valore:x}); });
      esclusivi(righe);
      if(vals.length===1){ righe[0].input.checked=true; }
      gruppi.push({tipo:'scelta',idx:i,righe:righe});
    });

    // optional
    var optRighe=[];
    var fissa=null;
    if(modo==='A'){
      var gb=gruppo('Prodotto','incluso');
      fissa=riga(gb,root.getAttribute('data-title')||'Prodotto','');
      fissa.input.checked=true; fissa.input.disabled=true; fissa.riga.classList.add('is-checked'); fissa.riga.style.cursor='default';
      var nomi=[];
      valori(iSpec).forEach(function(x){ if(SENZA.test(x)) return; x.replace(/^con\s+/i,'').split(' + ').forEach(function(p){ p=p.trim(); if(p && nomi.indexOf(p)<0) nomi.push(p); }); });
      var g=gruppo('Optional','facoltativi');
      nomi.forEach(function(p){ optRighe.push(Object.assign(riga(g,p,''),{nome:p})); });
    } else if(modo==='B'){
      var vals=valori(iSpec).filter(function(x){ return OPT.test(x); });
      var perPref={};
      vals.forEach(function(x){ var pulito=x.replace(OPT,''); var m=pulito.match(/^([^-]{2,30}) - /); var k=m?m[1].trim():''; (perPref[k]=perPref[k]||[]).push(x); });
      Object.keys(perPref).forEach(function(k){
        var lista=perPref[k]; var multi=k && lista.length>1;
        var g=gruppo(multi ? 'Optional - '+k : 'Optional', multi ? 'facoltativo, uno solo' : 'facoltativi');
        var rr=lista.map(function(x){
          var vv=V.filter(function(v){ return v.options[iSpec]===x; })[0];
          var testo=x.replace(OPT,''); if(multi) testo=testo.replace(new RegExp('^'+k.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')+'\\s*-\\s*'),'');
          return Object.assign(riga(g,testo,vv&&vv.sku||''),{valore:x,variante:vv});
        });
        if(multi) esclusivi(rr);
        optRighe=optRighe.concat(rr);
      });
    } else if(modo==='C'){
      var g=gruppo('Articoli','spunta quelli che ti servono');
      valori(iSpec).forEach(function(x){
        var vv=V.filter(function(v){ return v.options[iSpec]===x; })[0];
        optRighe.push(Object.assign(riga(g,x,vv&&vv.sku||''),{valore:x,variante:vv}));
      });
    }

    var T={A:['Scegli il prodotto e gli optional','Spunta gli optional che vuoi aggiungere: il prezzo si aggiorna da solo.'],
           B:['Scegli il prodotto e gli optional','Scegli il prodotto e, se vuoi, spunta gli optional da aggiungere al carrello insieme.'],
           C:['Scegli gli articoli','Spunta uno o più articoli e aggiungili tutti insieme al carrello.'],
           S:['Scegli il prodotto','Spunta una casella per ogni gruppo: il prezzo si aggiorna da solo.']}[modo];
    root.querySelector('[data-trp-cas-title]').textContent=T[0]; root.querySelector('[data-trp-cas-sub]').textContent=T[1];

    // ---- calcolo
    function scelteBase(){ return gruppi.map(function(g){ var r=g.righe.filter(function(x){ return x.input.checked; })[0]; return r?r.valore:null; }); }
    function varianteBase(sel, valSpec){
      return V.filter(function(v){
        return gruppi.every(function(g,k){ return sel[k]===null || v.options[g.idx]===sel[k]; }) &&
               (valSpec===undefined || v.options[iSpec]===valSpec);
      });
    }
    function setSpec(lista){ // A: valore della variante per un insieme di optional
      var vals=valori(iSpec);
      if(!lista.length) return vals.filter(function(x){ return SENZA.test(x); })[0];
      return vals.filter(function(x){
        if(SENZA.test(x)) return false;
        var parti=x.replace(/^con\s+/i,'').split(' + ').map(function(p){ return p.trim(); });
        return parti.length===lista.length && lista.every(function(p){ return parti.indexOf(p)>-1; });
      })[0];
    }
    function prezzoRiga(v){ return v ? (v.compare>v.price ? '<s>'+soldi(v.compare)+'</s>' : '')+'<strong>'+soldi(v.price)+'</strong>' : ''; }
    function piu(d){ return d>0 ? '+ '+soldi(d) : ''; }

    function aggiorna(){
      var sel=scelteBase(), q=parseInt(qty.value,10); if(!(q>0)) q=1;
      gruppi.forEach(function(g){ g.righe.forEach(function(r){ r.riga.classList.toggle('is-checked',r.input.checked); }); });
      optRighe.forEach(function(r){ r.riga.classList.toggle('is-checked',r.input.checked); });
      var mancanti=gruppi.filter(function(g,k){ return sel[k]===null; });
      var righe=[], prezzo=0, confronto=0, ok=true, avviso='';

      if(modo==='A'){
        var scelti=optRighe.filter(function(r){ return r.input.checked; }).map(function(r){ return r.nome; });
        var baseSpec=setSpec([]), vb=varianteBase(sel,baseSpec)[0];
        if(fissa){ fissa.prezzo.innerHTML=prezzoRiga(vb); var sk=fissa.riga.querySelector('.trp-cas__sku'); if(vb&&vb.sku&&!/^DS-/i.test(vb.sku)){ if(!sk){ sk=el('span','trp-cas__sku'); fissa.riga.querySelector('.trp-cas__name').appendChild(sk); } sk.textContent='Cod. '+vb.sku; } }
        optRighe.forEach(function(r){
          var vs=setSpec([r.nome]), vo=vs?varianteBase(sel,vs)[0]:null;
          r.prezzo.textContent=(vb&&vo)?piu(vo.price-vb.price):'';
        });
        gruppi.forEach(function(g,k){ g.righe.forEach(function(r){ var s=sel.slice(); s[k]=r.valore; var v=varianteBase(s,baseSpec)[0]; r.prezzo.innerHTML=prezzoRiga(v); }); });
        if(!mancanti.length){
          var spec=setSpec(scelti), v=spec?varianteBase(sel,spec)[0]:null;
          if(!v){ ok=false; avviso='Questa combinazione di optional non è disponibile online: scrivici e te la prepariamo.'; }
          else { righe=[{id:v.id,quantity:q}]; prezzo=v.price*q; confronto=(v.compare>v.price?v.compare:v.price)*q; if(!v.available){ ok=false; avviso='Non disponibile'; } }
        }
      } else {
        // B, C, S: prodotto scelto (se c'è) + optional come righe separate
        gruppi.forEach(function(g,k){ g.righe.forEach(function(r){ var s=sel.slice(); s[k]=r.valore; var v=varianteBase(s, modo==='B'?undefined:undefined).filter(function(x){ return modo!=='B' || !OPT.test(x.options[iSpec]); })[0]; r.prezzo.innerHTML=prezzoRiga(v); }); });
        optRighe.forEach(function(r){ r.prezzo.innerHTML=prezzoRiga(r.variante); if(r.variante && !r.variante.available){ r.input.disabled=true; r.riga.classList.add('is-disabled'); } });
        if(!mancanti.length && gruppi.length){
          var vb=varianteBase(sel).filter(function(x){ return modo!=='B' || !OPT.test(x.options[iSpec]); })[0];
          if(!vb){ ok=false; avviso='Combinazione non disponibile'; }
          else { righe.push({id:vb.id,quantity:q}); prezzo+=vb.price*q; confronto+=(vb.compare>vb.price?vb.compare:vb.price)*q; if(!vb.available){ ok=false; avviso='Non disponibile'; } }
        }
        optRighe.forEach(function(r){ if(r.input.checked && r.variante){ righe.push({id:r.variante.id,quantity:q}); prezzo+=r.variante.price*q; confronto+=(r.variante.compare>r.variante.price?r.variante.compare:r.variante.price)*q; } });
      }

      if(mancanti.length){
        info.textContent='Scegli: '+mancanti.map(function(g){ return g.righe.length ? (g.righe[0].riga.parentNode.querySelector('.trp-cas__gname').textContent) : ''; }).join(', ');
        tot.textContent='—'; cmp.textContent=''; save.textContent=''; btn.disabled=true; root._righe=null; return;
      }
      if(!righe.length){ info.textContent=modo==='C'?'Spunta almeno un articolo':'Completa le scelte'; tot.textContent='—'; cmp.textContent=''; save.textContent=''; btn.disabled=true; root._righe=null; return; }
      info.textContent=ok?(righe.length>1?'Totale ('+righe.length+' articoli)':'Totale'):avviso;
      tot.textContent=soldi(prezzo);
      cmp.textContent=confronto>prezzo?soldi(confronto):'';
      save.textContent=confronto>prezzo?'Risparmi '+soldi(confronto-prezzo):'';
      btn.disabled=!ok; root._righe=ok?righe:null;
    }

    root.addEventListener('change',aggiorna);
    qty.addEventListener('input',aggiorna);
    root.addEventListener('keydown',function(e){ if(e.key==='Enter' && e.target.matches('input')){ e.preventDefault(); } });
    btn.addEventListener('click',function(){
      var items=root._righe; if(!items||!items.length) return;
      btn.disabled=true; msg.textContent='Aggiunta al carrello in corso...';
      var r0=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      fetch(r0+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j; }); })
        .then(function(){ msg.textContent='Fatto! Ti porto al carrello...'; window.location.href=r0+'cart'; })
        .catch(function(e){ msg.textContent=(e&&(e.description||e.message))||'Non è stato possibile aggiungere al carrello, riprova.'; btn.disabled=false; });
    });
    aggiorna();
  });
})();
